import React from 'react';
import { Box, alpha } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const bounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
  30%           { transform: translateY(-5px); opacity: 1; }
`;

const Bubble = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '10px 14px',
  borderRadius: '18px 18px 18px 4px',
  background: theme.palette.mode === 'dark'
    ? alpha('#ffffff', 0.08)
    : alpha('#000000', 0.07),
  backdropFilter: 'blur(8px)',
  width: 'fit-content',
  marginLeft: '12px',
  marginBottom: '6px',
}));

const Dot = styled('span')(({ delay }) => ({
  width: 7,
  height: 7,
  borderRadius: '50%',
  background: 'currentColor',
  opacity: 0.4,
  animation: `${bounce} 1.3s ${delay}s infinite ease-in-out`,
}));

export default function TypingIndicator() {
  return (
    <Bubble>
      <Dot delay={0} />
      <Dot delay={0.15} />
      <Dot delay={0.3} />
    </Bubble>
  );
}
